import { heartPic, unheartPic } from '../actions/engageActions';

export function heartClicked(store, e) {
    e.preventDefault();
    e.stopPropagation();

    /*
    * selector: Dyanamically getting selector from the event handler's data param.
    * selectorClassList: Grabbing the list of classes and removing empty indexes.
    * hearting: Traversing DOM with template string.
    * picId: Grabbing the id of the picture that needs to be un/hearted.
    */
    const selector = $(e.target).closest(e.data.selector);
    const selectorClassList = $(selector).attr('class');

    if (!selectorClassList) { return false }

    const modifiedSelectorClassList = selectorClassList.split(' ').filter((entry) => entry.trim() !== '');

    const hearting = !$(`.${modifiedSelectorClassList.join('.')} .js-heart-toggle`).hasClass('is-hearted');
    const picId = selector.attr('data-pic-id');

    if (hearting) {
        store.dispatch(heartPic(picId));
    } else {
        store.dispatch(unheartPic(picId));
    }
    return false;
}

/**
 * Update all the picture tiles with the correct heart/unheart selection
 * @param picIdsInGrid array of picture ids in the grid
 * @param heartedPicIds Set of hearted pic ids
 */
export function updateGridHearts(picIdsInGrid, heartedPicIds) {
    const hearted = new Set(picIdsInGrid.filter((x) => heartedPicIds.has(x)));
    const unhearted = new Set(picIdsInGrid.filter((x) => !heartedPicIds.has(x)));

    hearted.forEach((picId) => {
        heartPicTile(picId);
    });

    unhearted.forEach((picId) => {
        unheartPicTile(picId);
    });
}

/**
 * Heart a UGC pic
 * @param picId Id of the UGC pic
 */
export function heartPicTile(picId) {
    $(`div[data-pic-id='${picId}'] .js-heart-toggle`).addClass('is-hearted');
}

/**
 * Unheart a UGC pic
 * @param picId Id of the UGC pic
 */
export function unheartPicTile(picId) {
    $(`div[data-pic-id='${picId}'] .js-heart-toggle`).removeClass('is-hearted');
}
